import {InMemoryCache} from '@apollo/client';
import dataIdFromObject from 'src/internal/shared/apollo/dataIdFromObject';

import type {SchemaConfig} from 'src/internal/revamp/config/types';
import type {PossibleTypes} from 'src/internal/shared/config/types';

export default function createCache(
  schemas: ReadonlyArray<SchemaConfig>,
): InMemoryCache {
  const possibleTypes: PossibleTypes = schemas.reduce(
    (acc, schema) => ({...acc, ...schema.possibleTypes}),
    {},
  );

  const anonymousTypes: string[] = schemas.flatMap(
    (schema) => schema.anonymousTypes,
  );

  return new InMemoryCache({
    possibleTypes,
    dataIdFromObject,
    typePolicies: Object.fromEntries(
      anonymousTypes.map((type) => [type, {merge: true}]),
    ),
  });
}
